import { render, staticRenderFns } from "./non-form-unsaved-changes-modal.vue?vue&type=template&id=084fb313"
import script from "./non-form-unsaved-changes-modal.vue?vue&type=script&lang=js"
export * from "./non-form-unsaved-changes-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports